import {
  getData, ifOkToJson, isDataFine, post, get,
  addRequestBody
} from './index'
// import {Cacheable} from '../../utils/cache'
import {bus} from '../../utils/bus'
import {httpUrl} from './httpUrl'

let baseUrl = `${httpUrl.host}/gy-lift`
// let baseUrl = `${httpUrl.localapi}/gy-lift`
let baseUrl85 = `${httpUrl.host}/gy-apartment`
let baseUrl84 = `${httpUrl.host}/gy-guard`

class Api {
  getLiftDeviceOverview () {
    return get(`${baseUrl}/liftOverview/getLiftDeviceOverview`, {})
      .then(ifOkToJson)
      .then(getData)
  }

  getLiftGatewayOverview () {
    return get(`${baseUrl}/liftOverview/getLiftGatewayOverview`, {})
      .then(ifOkToJson)
      .then(getData)
  }

  getLiftRecordStatictics (data) {
    return post(`${baseUrl}/liftOverview/getLiftRecordStatictics`, data)
      .then(ifOkToJson)
      .then(getData)
  }

  /* *********梯控设备管理********* */
  getAccessDevice (requestBody) {
    return post(`${baseUrl}/liftGateway/getPage`, requestBody)
      .then(ifOkToJson)
      .then(getData)
  }

  addAccessDevice (posDevice) {
    return post(`${baseUrl}/liftGateway/add`, posDevice)
      .then(ifOkToJson)
      .then(isDataFine)
  }

  getAccessDeviceByCode (code) {
    return get(`${baseUrl}/liftGateway/getByCode/${code}`)
      .then(ifOkToJson)
      .then(getData)
  }

  updateAccessDevice (posDevice) {
    return post(`${baseUrl}/liftGateway/update`, posDevice)
      .then(ifOkToJson)
      .then(isDataFine)
  }

  deleteAccessDevice (codes) {
    return post(`${baseUrl}/liftGateway/deleteByCodes`, codes)
      .then(ifOkToJson)
      .then(isDataFine)
  }

  getLiftGatewayList () {
    return post(`${baseUrl}/liftGateway/getList`, {})
      .then(ifOkToJson)
      .then(getData)
  }
  /* *********梯控设备管理********* */

  /* *********电梯管理********* */
  getLiftDevice (requestBody) {
    return post(`${baseUrl}/liftDevice/getPage`, requestBody)
      .then(ifOkToJson)
      .then(getData)
  }

  addLiftDevice (posDevice) {
    return post(`${baseUrl}/liftDevice/add`, posDevice)
      .then(ifOkToJson)
      .then(isDataFine)
  }

  getLiftDeviceByCode (code) {
    return get(`${baseUrl}/liftDevice/getByCode/${code}`)
      .then(ifOkToJson)
      .then(getData)
  }

  updateLiftDevice (posDevice) {
    return post(`${baseUrl}/liftDevice/update`, posDevice)
      .then(ifOkToJson)
      .then(isDataFine)
  }

  deleteLiftDevice (codes) {
    return post(`${baseUrl}/liftDevice/deleteByCodes`, codes)
      .then(ifOkToJson)
      .then(isDataFine)
  }

  getLiftDeviceList (data) {
    return post(`${baseUrl}/liftDevice/getList`, data || {})
      .then(ifOkToJson)
      .then(getData)
  }

  getBuildingList () {
    return post(`${baseUrl85}/building/getBuildingList`, {})
      .then(ifOkToJson)
      .then(getData)
  }
  /* *********电梯管理********* */

  /* *********授权管理********* */
  getLiftAuthorityPage (posDevice) {
    return post(`${baseUrl}/liftAuthority/getPage`, posDevice)
      .then(ifOkToJson)
      .then(getData)
  }
  getLiftAuthorityForEnterprisePage (posDevice) {
    return post(`${baseUrl}/liftAuthorityForEnterprise/getPage`, posDevice)
      .then(ifOkToJson)
      .then(getData)
  }
  updateLiftAuthority (posDevice) {
    return post(`${baseUrl}/liftAuthority/update`, posDevice)
      .then(ifOkToJson)
      .then(isDataFine)
  }
  updateLiftAuthorityForEnterprise (posDevice) {
    return post(`${baseUrl}/liftAuthorityForEnterprise/update`, posDevice)
      .then(ifOkToJson)
      .then(isDataFine)
  }
  deleteLiftAuthorityByCodes (codes) {
    return post(`${baseUrl}/liftAuthority/deleteByCodes`, codes)
      .then(ifOkToJson)
      .then(isDataFine)
  }
  deleteLiftAuthorityForEnterpriseByCodes (codes) {
    return post(`${baseUrl}/liftAuthorityForEnterprise/deleteByCodes`, codes)
      .then(ifOkToJson)
      .then(isDataFine)
  }
  addLiftAuthority (data) {
    return post(`${baseUrl}/liftAuthority/add`, data)
      .then(ifOkToJson)
      .then(isDataFine)
  }
  getLiftAuthorityByCode (code) {
    return post(`${baseUrl}/liftAuthority/getByCode/${code}`, {})
      .then(ifOkToJson)
      .then(getData)
  }
  /* *********授权管理********* */

  /* *********限制乘梯********* */
  getLiftBlackAuthorityPage (posDevice) {
    return post(`${baseUrl}/liftBlackAuthority/getPage`, posDevice)
      .then(ifOkToJson)
      .then(getData)
  }
  addLiftBlackAuthority (data) {
    return post(`${baseUrl}/liftBlackAuthority/add`, data)
      .then(ifOkToJson)
      .then(isDataFine)
  }
  deleteLiftBlackAuthorityByCodes (codes) {
    return post(`${baseUrl}/liftBlackAuthority/deleteByCodes`, codes)
      .then(ifOkToJson)
      .then(isDataFine)
  }
  /* *********限制乘梯********* */

  /* *********梯控计划********* */
  getLiftPlanPage (posDevice) {
    return post(`${baseUrl}/liftPlan/getPage`, posDevice)
      .then(ifOkToJson)
      .then(getData)
  }
  updateLiftPlan (posDevice) {
    return post(`${baseUrl}/liftPlan/update`, posDevice)
      .then(ifOkToJson)
      .then(isDataFine)
  }
  deleteLiftPlanByCodes (codes) {
    return post(`${baseUrl}/liftPlan/deleteByCodes`, codes)
      .then(ifOkToJson)
      .then(isDataFine)
  }
  addLiftPlan (data) {
    return post(`${baseUrl}/liftPlan/add`, data)
      .then(ifOkToJson)
      .then(isDataFine)
  }
  getLiftPlanByCode (code) {
    return get(`${baseUrl}/liftPlan/getByCode/${code}`, {})
      .then(ifOkToJson)
      .then(getData)
  }
  getLiftPlanList () {
    return post(`${baseUrl}/liftPlan/getList`, {})
      .then(ifOkToJson)
      .then(getData)
  }
  /* *********梯控计划********* */

  /* *********识别记录********* */
  getLiftRecordPage (data) {
    return post(`${baseUrl}/liftRecord/getPage`, data)
      .then(ifOkToJson)
      .then(getData)
  }
  /* *********识别记录********* */

  getResponsiblePersonList (searchKey) {
    return post(`${baseUrl}/person/getPersonListByName?searchKey=${searchKey}`)
      .then(ifOkToJson)
      .then(getData)
  }
  accessDeviceInfoDownloadUrl () {
    return `${baseUrl}/accessDevice/export?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}`
  }

  accessDeviceInfoUploadUrl () {
    return `${baseUrl}/accessDevice/import`
  }

  postAccessDevice (posDevice) {
    return post(`${baseUrl}/accessDevice/add`, posDevice)
      .then(ifOkToJson)
      .then(isDataFine)
  }

  getAllDeviceManufacture (data) {
    return post(`${baseUrl85}/common/getAllDeviceManufacture`, data)
      .then(ifOkToJson)
      .then(getData)
  }

  getAllDeviceType (data) {
    return post(`${baseUrl85}/common/getAllDeviceType`, data)
      .then(ifOkToJson)
      .then(getData)
  }

  // 设备状态日志
  getLiftGatewayDeviceStatusPage (reqData) {
    return post(`${baseUrl}/liftGatewayDeviceStatus/getPage`, reqData)
      .then(ifOkToJson)
      .then(getData)
  }

  exportLiftGatewayDeviceStatus () {
    return `${baseUrl}/liftGatewayDeviceStatus/export`
  }

  /* *********
   门禁授权
   ********* */
  getAuthority (requestBody) {
    return post(`${baseUrl}/authority/getPage`, requestBody)
      .then(ifOkToJson)
      .then(getData)
  }

  getResponsiblePerson (searchKey) {
    return post(`${baseUrl85}/person/getResponsiblePersonList`, {
      searchKey
    })
      .then(ifOkToJson)
      .then(getData)
  }

  getEnterpriseInfoList () {
    return post(`${baseUrl85}/enterpriseInfo/getEnterpriseList`, {})
      .then(ifOkToJson)
      .then(getData)
  }

  getAccessDeviceChildrenByCode (code) {
    return get(`${baseUrl}/organization/getOrgAndDevChildren/${code}`, {})
      .then(ifOkToJson)
      .then(getData)
  }

  getEnterpriseByCode (code) {
    return get(`${baseUrl85}/enterpriseInfo/getEnterpriseByCode/${code}`, {})
      .then(ifOkToJson)
      .then(getData)
  }

  getGatewayDeviceList (data) {
    return post(`${baseUrl}/accessDevice/getGatewayDeviceList`, data)
      .then(ifOkToJson)
      .then(getData)
  }

  getPersonList (data) {
    return post(`${baseUrl85}/person/getList`, data)
      .then(ifOkToJson)
      .then(getData)
  }

  getBasicPersonPage (data) {
    return post(`${baseUrl84}/authority/getPersonPage`, data)
      .then(ifOkToJson)
      .then(getData)
  }
}

const api = new Api()
export default api
export {api}



// WEBPACK FOOTER //
// ./src/view/api/LadderControl.js